import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { applyFilterNavigationHandler } from 'dias-core/utils/category/filter-navigation-utils';
import { Observable } from 'rxjs';

import { ShoppingFacade } from 'ish-core/facades/shopping.facade';
import { Facet } from 'ish-core/models/facet/facet.model';
import { FilterNavigation } from 'ish-core/models/filter-navigation/filter-navigation.model';
import { Filter } from 'ish-core/models/filter/filter.model';
import { URLFormParams } from 'ish-core/utils/url-form-params';

@Component({
  selector: 'custom-now-shopping-navigation',
  templateUrl: './now-shopping-navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NowShoppingNavigationComponent implements OnInit {
  @Input() fragmentOnRouting: string;
  filter$: Observable<FilterNavigation>;

  constructor(private shoppingFacade: ShoppingFacade, private router: Router, private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.filter$ = this.shoppingFacade.currentFilter$(true);
  }

  getActiveFilters(filterNavigation: FilterNavigation): Filter[] {
    const filters: Filter[] = [];

    filterNavigation?.filter?.forEach(filter => {
      let facets: Facet[] = [];
      facets = filter.facets.filter(
        (facet, index, self) => index === self.findIndex(t => t?.displayName === facet?.displayName) && facet.selected
      );
      if (facets.length) {
        const filterElement = {
          displayType: filter.displayType,
          facets,
          id: filter.id,
          limitCount: filter.limitCount,
          name: filter.name,
          selectionType: filter.selectionType,
        };
        filters.push(filterElement);
      }
    });
    return filters;
  }

  applyFilter(event: { searchParameter: URLFormParams }) {
    applyFilterNavigationHandler(event, this.router, this.activatedRoute);
  }
}
